import { Link, Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="mx-auto flex min-h-screen max-w-4xl flex-col px-6">
      <header className="flex items-center gap-4 py-4">
        <Link to="/" className="font-semibold text-bleu-nuit no-underline">
          New project
        </Link>
        <nav className="ml-auto flex gap-4 text-sm">
          <Link to="/" className="[&.active]:font-bold">
            Home
          </Link>
        </nav>
      </header>
      <main className="flex-1 py-8">
        <Outlet />
      </main>
    </div>
  );
}
